// import ProductBreifGuideSwiper from '@elem/compCommon/ProductConstructor/BriefGuide/Swiper';
import { FormatMoneyLocal, ShopifyCartItemType } from '@elem/compCommon/ShopifyShoppingCart/const';
import EFPicture from 'elem/compCommon/EFPicture';
import ShopifyCartIcon from '@elem/compCommon/ShopifyCartIcon';
import { createPortal } from 'react-dom';
import ShopifyShoppingCart from '@elem/compCommon/ShopifyShoppingCart';
import SubscribeA from '@elem/compPage/DP3/teaser/SubscribeA';
import EquityA from '@elem/compPage/DP3/teaser/EquityA';
import css from './index.module.scss';
import Points from './icons/Points';
import Light from './icons/Light';
import DialogForm from './components/DialogForm';
import TemplateModal from './components/TemplateModal';
import AutoSwiper from './components/AutoSwiper';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';
import topics from '@/utils/mqtt-client/crowd-funding-topics';
import wss from '@/utils/mqtt-client';
import { getWSSUrl } from '@/utils/countryRegion';
import EfLink from '@elem/ui/ef-link';

// let n = 0;
export default function BundleJP() {
    const { useState, useEffect, useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('dp3.crowdfunding.bundle');
    const { t: s } = useLang('shared.product.bundles');
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const [shoppingCarts, setShoppingCarts] = useState([] as ShopifyCartItemType[]);
    const [showCart, setShowCart] = useState(false);
    const [tempObj, setTempObj] = useState(null);
    const [pdfBundle, setPDFBundle] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const subscribes = ['inventory'];
    const url = String(getWSSUrl(locale));

    const { receiver, mqttUnsubscribe, mqttSubscribe } = wss({
        url,
        topics,
        locale,
        subscribes,
        activityId: 60,
    });

    const handleCallback = (carts: ShopifyCartItemType[], isClose: boolean) => {
        setShoppingCarts(carts);
        if (isClose) {
            setShowCart(false);
        }
    };

    const handleAddCart = (bundle: any, listName: string) => {
        if (Number(bundle?.inventory) <= 0) {
            return;
        }
        const { title, img, productId, variantId, quantity = 1, discountPrice, originalPrice, inventory } = bundle;
        const cart = {
            title,
            img,
            productId,
            variantId,
            quantity,
            discountPrice,
            originalPrice,
            inventory,
        } as ShopifyCartItemType;
        const obj: ShopifyCartItemType = JSON.parse(JSON.stringify(cart));
        const target = shoppingCarts.find((item: ShopifyCartItemType) => item?.productId === cart?.productId && item?.variantId === cart?.variantId);
        if (target) {
            obj.quantity = Number(target?.quantity || 0) + (Number(target?.quantity) < Number(target?.inventory) ? 1 : 0);
            setShoppingCarts([
                obj,
                ...shoppingCarts?.filter((item: ShopifyCartItemType) => !(item?.productId === cart?.productId && item?.variantId === cart?.variantId)),
            ]);
        } else {
            obj.quantity = Number(obj?.inventory) > 0 ? 1 : 0;
            setShoppingCarts([obj, ...shoppingCarts]);
        }
        setShowCart(true);
        let o = null;
        if (bundle.stages[bundle.statu] && bundle.stages[bundle.statu][bundle.stage]) {
            o = bundle.stages[bundle.statu][bundle.stage];
        } else {
            o = bundle.stages[bundle.stage];
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: listName,
            product_name: bundle?.title,
            price: bundle?.discountPrice,
            tag:
                bundle?.stage === 0
                    ? t.rich('discount_tag_super', {
                          n: o.percent,
                      })
                    : bundle?.stage === 1
                    ? t.rich('discount_tag_early', {
                          n: o.percent,
                      })
                    : t('discount_tag_common', {
                          n: o.percent,
                      }),
            quantity: 1,
            button_name: t('link_cart'),
        });
    };

    const handleOpenQuote = (bundle: any) => {
        setPDFBundle(bundle);
        setShowModal(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_get_a_quote',
            product_name: bundle?.title,
            position: 'Introduction',
            option_name: t('group1_title'),
        });
    };

    const AddReduceCalc = ({ data, callback, tag, subtitle }: any) => {
        const NUM_MIN = data?.min || 0;
        const NUM_MAX = data?.max || 0;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);
        const [showMaxTip, setShowMaxTip] = useState(false);

        const reduceNumber = () => {
            if (number <= NUM_MIN) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.title,
                    price: 0,
                    quantity: number - 1,
                    button_name: 'remove',
                    list_name: subtitle,
                    tag,
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (number >= NUM_MAX) {
                setShowMaxTip(true);
                setTimeout(() => {
                    setShowMaxTip(false);
                }, 2000);
                return false;
            }
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.title,
                    price: 0,
                    quantity: number + 1,
                    button_name: 'add',
                    list_name: subtitle,
                    tag,
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        return (
            <div className="bundle-calculator">
                <div className={number <= NUM_MIN ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="24" height="24" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {/* <div className="addSubtractor-number">{number}</div> */}
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                <div className={number >= NUM_MAX ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={addNumber}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <g className="svg-g">
                            <rect width="100%" height="100%" rx="12" fill="#38383D" />
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                                fill="#E6E6E6"
                            />
                        </g>
                    </svg>
                </div>
                {showMaxTip && <p className="reach-max">{s('reach_max')}</p>}
            </div>
        );
    };

    const updateBundle1 = (data: any) => {
        const resultArr = [];
        const tempList = JSON.parse(JSON.stringify(bundles1));
        tempList.forEach((item: any) => {
            const targetIndex = data?.findIndex((list: any) => item?.variantId === list?.variantId);
            if (targetIndex !== -1) {
                const tempStages = item.stages[item.statu];
                let record = false;
                tempStages?.map((stage: any, k: number) => {
                    const dataProduct = data.find((li: any) => stage?.variantId === li?.variantId && (li?.inventory > 0 || k === tempStages?.length - 1));
                    if (dataProduct && !record) {
                        item.stage = k;
                        item.inventory = Number(dataProduct?.inventory);
                        item.productId = dataProduct?.productId;
                        item.variantId = dataProduct?.variantId;
                        item.discountPrice = dataProduct?.price;
                        item.originalPrice = dataProduct?.compareAtPrice || dataProduct?.price;
                        item.link_buy = `https://${locale}.ecoflow.com/cart/${dataProduct?.variantId}:1?channel=buy_button`;
                        item.img = dataProduct?.img;
                        item.point = FormatMoneyLocal(Math.round((item?.discountPrice / 150) * 5), locale)
                            .replace('（税込）', '')
                            .replace('¥', '');
                        item.total = item.stages[item.statu][k].total;
                        record = true;
                        resultArr.push(item);
                    }
                });
            }
        });
        setBundles1(resultArr);
    };

    const updateBundle2 = (data: any) => {
        const resultArr = [];
        const tempList = JSON.parse(JSON.stringify(bundles2));
        tempList.forEach((item: any) => {
            const targetIndex = data?.findIndex((list: any) => item?.variantId === list?.variantId);
            if (targetIndex !== -1) {
                const tempStages = item.stages;
                let record = false;
                tempStages?.map((stage: any, k: number) => {
                    const dataProduct = data.find((li: any) => stage?.variantId === li?.variantId && (li.inventory > 0 || k === tempStages.length - 1));
                    if (dataProduct && !record) {
                        item.stage = k;
                        item.inventory = Number(dataProduct?.inventory);
                        item.productId = dataProduct?.productId;
                        item.variantId = dataProduct?.variantId;
                        item.discountPrice = dataProduct?.price;
                        item.originalPrice = dataProduct?.compareAtPrice || dataProduct?.price;
                        item.link_buy = `https://${locale}.ecoflow.com/cart/${dataProduct?.variantId}:1?channel=buy_button`;
                        item.img = dataProduct?.img;
                        // 改为5倍积分
                        item.point = FormatMoneyLocal(Math.round((item?.discountPrice / 150) * 5), locale)
                            .replace('（税込）', '')
                            .replace('¥', '');
                        item.total = item.stages[k].total;
                        record = true;
                        resultArr.push(item);
                    }
                });
            }
        });
        setBundles2(resultArr);
    };

    const mqttUpdateBundles = (data: any) => {
        updateBundle1(data);
        updateBundle2(data);
    };

    useEffect(() => {
        const { data } = receiver;
        // if(n === 0){
        //     console.log('data---', data);
        // }
        if (data?.length > 0) {
            //     const idx1 = data?.findIndex((item:any) => item.variantId === '44261300175009');
            //     const idx2 = data?.findIndex((item:any) => item.variantId === '44261300207777');
            //     const idx3 = data?.findIndex((item:any) => item.variantId === '44261316657313');
            //     if(n >= 2 && n < 4){
            //         console.log('n-idx1-idx2-idx3: ', n, idx1, idx2, idx3);
            //         data[idx1].inventory = 0;
            //         data[idx2].inventory = 100;
            //         data[idx3].inventory = 0;
            //     }
            //     if(n >= 4 && n < 6){
            //         console.log('n-idx1-idx2-idx3: ', n, idx1, idx2, idx3);
            //         data[idx1].inventory = 120;
            //         data[idx2].inventory = 0;
            //         data[idx3].inventory = 100;
            //     }
            //     n++;
            mqttUpdateBundles(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [receiver]);

    useEffect(() => {
        mqttSubscribe('inventory');
        return () => mqttUnsubscribe('inventory');
    }, []);

    const swiperArr1 = [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719040716383/2_1.jpg',
            imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719199637684/Frame%201000008451%20(1).jpg',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1720410629384/PC_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%2BQUO.jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1720410697908/Mob_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%2BQUO.jpg',
        },
    ];

    const swiperArr2 = [
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719040716383/2_1.jpg',
            imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719199637684/Frame%201000008451%20(1).jpg',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1720425418922/PC_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%20(1).jpg',
            imgPad: 'https://websiteoss.ecoflow.com/upload/image/1720425472860/Mob_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%20(1).jpg',
        },
    ];

    // GROUP1
    const group1 = [
        {
            subtitle: t('group1_item2_subtitle'),
            sub_quantity: 0,
            // quantity: 1,
            stage: 0,
            statu: 0,
            stages: [
                [
                    {
                        productId: '7990573596833',
                        variantId: '44261300175009',
                        total: 200,
                        percent: 30,
                    },
                    {
                        productId: '7990573596833',
                        variantId: '44261300207777',
                        total: 200,
                        percent: 25,
                    },
                    {
                        productId: '7990573596833',
                        variantId: '44261316657313',
                        total: 200,
                        percent: 20,
                    },
                ],
                [
                    {
                        productId: '7990582345889',
                        variantId: '44261317935265',
                        total: 200,
                        percent: 30,
                    },
                    {
                        productId: '7990582345889',
                        variantId: '44261317968033',
                        total: 200,
                        percent: 25,
                    },
                    {
                        productId: '7990582345889',
                        variantId: '44261350277281',
                        total: 200,
                        percent: 20,
                    },
                ],
            ],
            subs: [
                {
                    parentVariantId: '7990573596833',
                    title: t('group1_item2_sub1_title'),
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719197609569/sl_DP3EB%20(1).png',
                    quantity: 0,
                    min: 0,
                    max: 1,
                },
            ],
            changeSwiper: true,
            swiperArr: swiperArr1,
        },
        {
            subtitle: t('group1_item1_subtitle'),
            quotation: true,
            sub_quantity: 1,
            // quantity: 1,
            stage: 0,
            statu: 0,
            stages: [
                [
                    {
                        productId: '8025426133153',
                        variantId: '44333276922017',
                        total: 200,
                        percent: 35,
                    },
                    {
                        productId: '8025426133153',
                        variantId: '44333276954785',
                        total: 200,
                        percent: 30,
                    },
                    {
                        productId: '8025426133153',
                        variantId: '44333276987553',
                        total: 200,
                        percent: 25,
                    },
                ],
                [
                    {
                        productId: '8025433931937',
                        variantId: '44333283934369',
                        total: 200,
                        percent: 35,
                    },
                    {
                        productId: '8025433931937',
                        variantId: '44333283967137',
                        total: 200,
                        percent: 30,
                    },
                    {
                        productId: '8025433931937',
                        variantId: '44333283999905',
                        total: 200,
                        percent: 25,
                    },
                ],
            ],
            subs: [
                {
                    parentVariantId: '44333276922017',
                    title: t('group1_item1_sub1_title'),
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719197535486/sl_DP3EB.png',
                    capacity: 4,
                    quantity: 1,
                    min: 1,
                    max: 2,
                },
            ],
            swiperArr: [
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719040456962/1_2.jpg',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719199602662/Frame%201000008456%20(1).jpg',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1720425418922/PC_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%20(1).jpg',
                    imgPad: 'https://websiteoss.ecoflow.com/upload/image/1720425472860/Mob_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%20(1).jpg',
                },
            ],
        },
        {
            subtitle: t('group1_item3_subtitle'),
            sub_quantity: 1,
            // quantity: 1,
            stage: 0,
            statu: 0,
            stages: [
                [
                    {
                        productId: '7990617145505',
                        variantId: '44261385437345',
                        total: 200,
                        percent: 30,
                    },
                    {
                        productId: '7990617145505',
                        variantId: '44261385470113',
                        total: 200,
                        percent: 25,
                    },
                    {
                        productId: '7990617145505',
                        variantId: '44261385502881',
                        total: 200,
                        percent: 20,
                    },
                ],
                [
                    {
                        productId: '7991822647457',
                        variantId: '44263012761761',
                        total: 200,
                        percent: 30,
                    },
                    {
                        productId: '7991822647457',
                        variantId: '44263012794529',
                        total: 200,
                        percent: 25,
                    },
                    {
                        productId: '7991822647457',
                        variantId: '44263012827297',
                        total: 200,
                        percent: 20,
                    },
                ],
            ],
            subs: [
                {
                    parentVariantId: '44261385437345',
                    title: t('group1_item3_sub1_title'),
                    img: '/responsive/picture/common-products/400w.png',
                    quantity: 1,
                    min: 1,
                    max: 2,
                },
            ],
            swiperArr: [
                {
                    img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719040805570/3_1.jpg',
                    imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719199652790/Frame%201000008449%20(1).jpg',
                },
                {
                    img: 'https://websiteoss.ecoflow.com/upload/image/1720425418922/PC_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%20(1).jpg',
                    imgPad: 'https://websiteoss.ecoflow.com/upload/image/1720425472860/Mob_%E5%A2%9E%E5%8A%A0%E6%96%B0%E6%9D%83%E7%9B%8A%20(1).jpg',
                },
            ],
        },
    ];
    const [cardBundles1, setCardBundles1] = useState(group1);
    const [bundles1, setBundles1] = useState(cardBundles1);

    const handleCalculate1 = (data: any, n: number, k: number, m: number) => {
        const tempBundles = JSON.parse(JSON.stringify(bundles1));
        const pObj = tempBundles[k];
        if (pObj) {
            pObj.sub_quantity = n;
            const target = tempBundles[k].subs[m];
            if (target) {
                target.quantity = n;
                pObj.statu = n === target?.min ? 0 : n === target?.max ? 1 : -1;
            }
        }
        if (pObj?.changeSwiper) {
            pObj.swiperArr = n === 0 ? swiperArr1 : n === 1 ? swiperArr2 : [];
        }
        setCardBundles1(tempBundles);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    useEffect(() => {
        const tempBundles = JSON.parse(JSON.stringify(cardBundles1));
        tempBundles?.map((bundle: any, k: number) => {
            const stages = bundle.stages[bundle?.statu];
            const stage = stages?.find((st: any, m: number) => st?.inventory > 0 || m === stages?.length - 1);
            const stageIdx = stages?.findIndex((st: any, m: number) => st?.inventory > 0 || m === stages?.length - 1);
            if (stageIdx !== -1) {
                bundle.stage = stageIdx;
            }
            if (stage?.productId && stage?.variantId) {
                bundle.productId = stage.productId;
                bundle.variantId = stage.variantId;
                bundle.inventory = Number(stage?.inventory);
                bundle.discountPrice = stage.discountPrice;
                bundle.originalPrice = stage.originalPrice;
                bundle.link_buy = `https://${locale}.ecoflow.com/cart/${stage.variantId}:1?channel=buy_button`;
                bundle.total = stage.total;
                bundle.img = stage.img;
                bundle.title = stage.title;
                bundle.point = FormatMoneyLocal(Math.round((bundle?.discountPrice / 150) * 5), locale)
                    .replace('（税込）', '')
                    .replace('¥', '');
            }
        });
        setBundles1(tempBundles);
    }, [cardBundles1, locale]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardBundles1));
        const getAsynItem = async (productId: string, variantId: string, k: number, m: number, n: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.img) {
                            tempArr[k].stages[m][n].img = res?.data?.img;
                        }
                        if (res?.data?.skuTitle || res?.data?.productTitle) {
                            tempArr[k].stages[m][n].title = res?.data?.productTitle || res?.data?.skuTitle;
                        }
                        tempArr[k].stages[m][n].discountPrice = res?.data?.price;
                        tempArr[k].stages[m][n].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].stages[m][n].inventory = res?.data?.inventoryQuantity ?? 0;
                        // tempArr[k].stages[m].inventory = 4;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempArr?.map((item: any, k: number) => {
            item?.stages?.map((section: any, m: number) => {
                section?.map((list: any, n: number) => {
                    if (list?.variantId) {
                        promises.push(getAsynItem(list?.productId, list.variantId, k, m, n));
                    }
                });
            });
        });

        Promise.all(promises)
            .then(() => {
                setCardBundles1(tempArr);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    const renderGroup1 = (
        <div className="big-group group1">
            <p className="g-title">{t('group1_title')}</p>
            <ul className="bundles">
                {bundles1?.map((bundle: any, k: number) => (
                    <li className={`bundle bundle-${k + 1}`} key={k}>
                        <div className="bundle-imgs">
                            <AutoSwiper
                                key={k}
                                // swiperArr={bundle?.statu === 0 ? [bundle.statu1Img, ...bundle?.swiperArr] : [bundle.statu2Img, ...bundle?.swiperArr]}
                                swiperArr={[
                                    {
                                        img: bundle.img,
                                        imgPad: bundle.img,
                                    },
                                    ...bundle?.swiperArr,
                                ]}
                            />
                            <div className="floats">
                                <span className="discount-tag">
                                    {bundle?.stage === 0
                                        ? t.rich('discount_tag_super', {
                                              n: bundle.stages[bundle.statu][bundle.stage].percent,
                                          })
                                        : bundle?.stage === 1
                                        ? t.rich('discount_tag_early', {
                                              n: bundle.stages[bundle.statu][bundle.stage].percent,
                                          })
                                        : t('discount_tag_common', {
                                              n: bundle.stages[bundle.statu][bundle.stage].percent,
                                          })}
                                </span>
                                <span className="point-tag">
                                    <Points />
                                    <span className="rate">{t('double_tag')}</span>
                                    <span className={`point ${bundle?.point?.length > 5 ? 'long' : 'short'}`}>
                                        {t.rich('point', {
                                            point: bundle?.point,
                                        })}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="bundle-info">
                            <div className="info-inner">
                                {bundle?.subtitle && <p className="bundle-subtitle">{bundle?.subtitle}</p>}
                                <p className="bundle-title">{bundle?.title}</p>
                                <div className="bundle-price">
                                    <span className="price-discount">
                                        {FormatMoneyLocal(bundle?.discountPrice, locale).replace('（税込）', '')}
                                        <span className="tax">（税込）</span>
                                    </span>
                                    {bundle?.originalPrice !== bundle?.discountPrice && (
                                        <span className="price-original">
                                            {t('original_price')}
                                            {FormatMoneyLocal(bundle?.originalPrice, locale)}
                                        </span>
                                    )}
                                </div>
                                <ul className="bundle-subs">
                                    {bundle?.subs?.map((sub: any, m: number) => (
                                        <li className={`bundle-sub ${sub?.capacity ? 'has-capacity' : ''}`} key={`${k}_${m}`}>
                                            <div className="sub-box">
                                                <div className="sub-info">
                                                    <div className="sub-img">
                                                        <EFPicture src={sub?.img} alt={sub?.title} />
                                                    </div>
                                                    <p className="sub-title">{sub?.title}</p>
                                                </div>
                                                <AddReduceCalc
                                                    data={sub}
                                                    tag={bundle?.title}
                                                    subtitle={bundle?.subtitle}
                                                    callback={(data, n) => handleCalculate1(data, n, k, m)}
                                                />
                                            </div>
                                            {sub?.capacity && (
                                                <div className="sub-capacity">
                                                    <div className="capacity-inner">
                                                        <p className="capacity-label">{t('capacity')}</p>
                                                        <p className="capacity-num">{`${Number(sub?.capacity) * Number(sub?.quantity || 1) + 4}kWh`}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                                <div className={`bundle-btns ${bundle?.quotation ? 'has-quotation' : ''}`}>
                                    <button
                                        className={`btn link-cart ${Number(bundle?.inventory) <= 0 && bundle?.stage === 2 ? 'disable' : ''}`}
                                        onClick={() => handleAddCart(bundle, t('group1_title'))}
                                    >
                                        {t('link_cart')}
                                    </button>
                                    {bundle?.inventory > 0 && (
                                        <EfLink
                                            href={(bundle?.link_buy, locale) || ''}
                                            target="_blank"
                                            className="btn link-buy"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'checkout',
                                                button_name: `${t('link_buy')}_${bundle?.title}`,
                                            }}
                                        >
                                            {t('link_buy')}
                                        </EfLink>
                                    )}
                                    {Number(bundle?.inventory) <= 0 && bundle?.stage === 2 && (
                                        <button className="btn link-buy disable">{t('link_sold_out')}</button>
                                    )}
                                    {bundle?.quotation && (
                                        <button className="btn link-quote link-buy" onClick={() => handleOpenQuote(bundle)}>
                                            {t('link_quote')}
                                        </button>
                                    )}
                                </div>
                                <div className="bar-box">
                                    <Light />
                                    <ul className="bars">
                                        <li className={`bar-item super ${bundle?.stage > 0 || bundle?.total !== Number(bundle?.inventory) ? 'colored' : ''}`}>
                                            <p className="bar-line">
                                                <p
                                                    className="after"
                                                    style={{
                                                        width:
                                                            bundle?.stage > 0
                                                                ? '100%'
                                                                : `${((bundle?.total - Number(bundle?.inventory)) / bundle?.total) * 100}%`,
                                                    }}
                                                ></p>
                                            </p>
                                            <p className="bar-text">
                                                {t.rich('super_early', {
                                                    n: bundle.stages[bundle.statu][0].percent,
                                                })}
                                            </p>
                                        </li>
                                        <li
                                            className={`bar-item early ${
                                                bundle?.stage > 1 || (bundle?.stage === 1 && bundle?.total !== bundle?.inventory) ? 'colored' : ''
                                            }`}
                                        >
                                            <p className="bar-line">
                                                <p
                                                    className="after"
                                                    style={{
                                                        width:
                                                            bundle?.stage === 0
                                                                ? '0%'
                                                                : bundle?.stage > 1
                                                                ? '100%'
                                                                : `${((bundle?.total - Number(bundle?.inventory)) / bundle?.total) * 100}%`,
                                                    }}
                                                ></p>
                                            </p>
                                            <p className="bar-text">
                                                {t.rich('early', {
                                                    n: bundle.stages[bundle.statu][1].percent,
                                                })}
                                            </p>
                                        </li>
                                        <li className={`bar-item common ${bundle.stage > 1 && bundle?.total !== bundle?.inventory ? 'colored' : ''}`}>
                                            <p className="bar-line">
                                                <p
                                                    className="after"
                                                    style={{
                                                        width:
                                                            bundle.stage < 2 ? '0%' : `${((bundle?.total - Number(bundle?.inventory)) / bundle?.total) * 100}%`,
                                                    }}
                                                ></p>
                                            </p>
                                            <p className="bar-text">
                                                {t.rich('common', {
                                                    n: bundle.stages[bundle.statu][2].percent,
                                                })}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );

    // GROUP2
    const group2 = [
        {
            title: t('group1_item2_title'),
            img: '/responsive/picture/common-products/delta_pro_ultra.png',
            stage: 0,
            // quantity: 1,
            stages: [
                {
                    productId: '7989887631521',
                    variantId: '44257681014945',
                    total: 200,
                    percent: 30,
                },
                {
                    productId: '7989887631521',
                    variantId: '44257681047713',
                    total: 200,
                    percent: 25,
                },
                {
                    productId: '7989887631521',
                    variantId: '44257681080481',
                    total: 200,
                    percent: 20,
                },
            ],
        },
        {
            title: t('group1_item1_title'),
            img: '/responsive/picture/common-products/delta_pro_ultra.png',
            // quantity: 1,
            stage: 0,
            stages: [
                {
                    productId: '7990885023905',
                    variantId: '44261746442401',
                    total: 200,
                    percent: 30,
                },
                {
                    productId: '7990885023905',
                    variantId: '44261746475169',
                    total: 200,
                    percent: 25,
                },
                {
                    productId: '7990885023905',
                    variantId: '44261746507937',
                    total: 200,
                    percent: 20,
                },
            ],
        },
    ];
    const [cardBundles2, setCardBundles2] = useState(group2);
    const [bundles2, setBundles2] = useState(cardBundles2);

    useEffect(() => {
        const tempBundles = JSON.parse(JSON.stringify(cardBundles2));
        tempBundles?.map((bundle: any, k: number) => {
            const target = bundle.stages;
            const stage = target?.find((st: any) => st?.inventory > 0);
            const stageIdx = target?.findIndex((st: any) => st?.inventory > 0);
            if (stageIdx !== -1) {
                bundle.stage = stageIdx;
            }
            if (stage?.productId && stage?.variantId) {
                bundle.productId = stage.productId;
                bundle.variantId = stage.variantId;
                bundle.inventory = stage.inventory;
                bundle.discountPrice = stage.discountPrice;
                bundle.originalPrice = stage.originalPrice;
                bundle.link_buy = `https://${locale}.ecoflow.com/cart/${stage.variantId}:1?channel=buy_button`;
                bundle.total = stage.total;
                bundle.img = stage.img;
                bundle.title = stage.title;
                bundle.point = FormatMoneyLocal(Math.round((bundle?.discountPrice / 150) * 5), locale)
                    .replace('（税込）', '')
                    .replace('¥', '');
            }
        });
        setBundles2(tempBundles);
    }, [cardBundles2, locale]);

    useEffect(() => {
        const tempArr = JSON.parse(JSON.stringify(cardBundles2));
        const getAsynItem = async (productId: string, variantId: string, k: number, m: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.img) {
                            tempArr[k].stages[m].img = res?.data?.img;
                        }
                        if (res?.data?.skuTitle || res?.data?.productTitle) {
                            tempArr[k].stages[m].title = res?.data?.productTitle || res?.data?.skuTitle;
                        }
                        tempArr[k].stages[m].discountPrice = res?.data?.price;
                        tempArr[k].stages[m].originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        tempArr[k].stages[m].inventory = res?.data?.inventoryQuantity ?? 0;
                        // tempArr[k].stages[m].inventory = 4;
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        };

        const promises = [];
        tempArr?.map((item: any, k: number) => {
            item?.stages?.map((list: any, m: number) => {
                if (list?.variantId) {
                    promises.push(getAsynItem(list?.productId, list.variantId, k, m));
                }
            });
        });

        Promise.all(promises)
            .then(() => {
                setCardBundles2(tempArr);
            })
            .catch((e) => {
                console.error(e);
            });
    }, []);

    const renderGroup2 = (
        <div className="big-group group2">
            <p className="g-title">{t('group2_title')}</p>
            <ul className="bundles">
                {bundles2?.map((bundle: any, k: number) => (
                    <li className={`bundle bundle-${k + 1}`} key={k}>
                        <div className="bundle-img bundle-imgs">
                            <EFPicture src={bundle?.img} alt={bundle?.title} />
                            <div className="floats">
                                <span className="discount-tag">
                                    {bundle?.stage === 0
                                        ? t.rich('discount_tag_super', {
                                              n: bundle.stages[bundle.stage].percent,
                                          })
                                        : bundle?.stage === 1
                                        ? t.rich('discount_tag_early', {
                                              n: bundle.stages[bundle.stage].percent,
                                          })
                                        : t.rich('discount_tag_common', {
                                              n: bundle.stages[bundle.stage].percent,
                                          })}
                                </span>
                                <span className="point-tag">
                                    <Points />
                                    <span className="rate">{t('double_tag')}</span>
                                    <span className={`point ${bundle?.point?.length > 5 ? 'long' : 'short'}`}>
                                        {t.rich('point', {
                                            point: bundle?.point,
                                        })}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div className="bundle-info">
                            <div className="info-inner">
                                <p className="bundle-title">{bundle?.title}</p>
                                <div className="bundle-price">
                                    <span className="price-discount">
                                        {FormatMoneyLocal(bundle?.discountPrice, locale).replace('（税込）', '')}
                                        <span className="tax">（税込）</span>
                                    </span>
                                    {bundle?.discountPrice !== bundle?.originalPrice && (
                                        <span className="price-original">
                                            {t('original_price')}
                                            {FormatMoneyLocal(bundle?.originalPrice, locale)}
                                        </span>
                                    )}
                                </div>
                                <div className="bundle-btns">
                                    <button
                                        className={`btn link-cart ${Number(bundle?.inventory) <= 0 && bundle?.stage === 2 ? 'disable' : ''}`}
                                        onClick={() => handleAddCart(bundle, t('group2_title'))}
                                    >
                                        {t('link_cart')}
                                    </button>
                                    {bundle?.inventory > 0 && (
                                        <EfLink
                                            href={bundle?.link_buy || ''}
                                            target="_blank"
                                            className="btn link-buy"
                                            dataLayer={{
                                                event: 'uaEvent',
                                                event_name: 'checkout',
                                                button_name: `${t('link_buy')}_${bundle?.title}`,
                                            }}
                                        >
                                            {t('link_buy')}
                                        </EfLink>
                                    )}
                                    {Number(bundle?.inventory) <= 0 && bundle?.stage === 2 && (
                                        <button className="btn link-buy disable">{t('link_sold_out')}</button>
                                    )}
                                </div>
                                <div className="bar-box">
                                    <Light />
                                    <ul className="bars">
                                        <li className={`bar-item super ${bundle?.stage > 0 || bundle?.total !== Number(bundle?.inventory) ? 'colored' : ''}`}>
                                            <p className="bar-line">
                                                <p
                                                    className="after"
                                                    style={{
                                                        width:
                                                            bundle?.stage > 0
                                                                ? '100%'
                                                                : `${((bundle?.total - Number(bundle?.inventory)) / bundle?.total) * 100}%`,
                                                    }}
                                                ></p>
                                            </p>
                                            <p className="bar-text">
                                                {t.rich('super_early', {
                                                    n: bundle.stages[0].percent,
                                                })}
                                            </p>
                                        </li>
                                        <li
                                            className={`bar-item early ${
                                                bundle?.stage > 1 || (bundle?.stage === 1 && bundle?.total !== bundle?.inventory) ? 'colored' : ''
                                            }`}
                                        >
                                            <p className="bar-line">
                                                <p
                                                    className="after"
                                                    style={{
                                                        width:
                                                            bundle?.stage === 0
                                                                ? '0%'
                                                                : bundle?.stage > 1
                                                                ? '100%'
                                                                : `${((bundle?.total - Number(bundle?.inventory)) / bundle?.total) * 100}%`,
                                                    }}
                                                ></p>
                                            </p>
                                            <p className="bar-text">
                                                {t.rich('early', {
                                                    n: bundle.stages[1].percent,
                                                })}
                                            </p>
                                        </li>
                                        <li className={`bar-item common ${bundle.stage > 1 && bundle?.total !== bundle?.inventory ? 'colored' : ''}`}>
                                            <p className="bar-line">
                                                <p
                                                    className="after"
                                                    style={{
                                                        width:
                                                            bundle.stage < 2 ? '0%' : `${((bundle?.total - Number(bundle?.inventory)) / bundle?.total) * 100}%`,
                                                    }}
                                                ></p>
                                            </p>
                                            <p className="bar-text">
                                                {t.rich('common', {
                                                    n: bundle.stages[2].percent,
                                                })}
                                            </p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );

    return (
        <div className={`dp3-crowdfunding-bundle ${css['dp3-crowdfunding-bundle']}`}>
            {bundles1?.length > 0 && renderGroup1}
            {bundles2?.length > 0 && renderGroup2}
            <SubscribeA />
            <EquityA />
            {pdfBundle &&
                showModal &&
                isClient &&
                createPortal(
                    <DialogForm
                        dataObj={pdfBundle}
                        callback={(type: string, obj: any) => {
                            if (type === 'quotation' && obj) {
                                setTempObj({ ...pdfBundle, ...obj });
                            }
                            setShowModal(false);
                        }}
                    />,
                    document.body,
                )}
            {tempObj && isClient && createPortal(<TemplateModal obj={tempObj} callback={() => setTempObj(null)} />, document.body)}
            {showCart && isClient && createPortal(<ShopifyShoppingCart callback={handleCallback} items={shoppingCarts} />, document.body)}
            {isClient &&
                createPortal(
                    <ShopifyCartIcon
                        quantity={shoppingCarts.reduce((prev: number, curItem: ShopifyCartItemType) => {
                            return prev + Number(curItem?.quantity || 0);
                        }, 0)}
                        callback={() => setShowCart(true)}
                    />,
                    document.body,
                )}
            <style jsx global>
                {`
                    .shopify-cart-icon {
                        bottom: 197px;
                    }
                    @media (max-width: 1024px) {
                        .shopify-cart-icon {
                            bottom: 186px;
                        }
                    }
                `}
            </style>
        </div>
    );
}
